<template>
  <ViewCustomRow @refreshRow="refreshRow" @addNewRow="addNewRow" v-model:showRowDialog="showDialog" :rowId="rowId"
    :permissions="permissions" :masterDetail="masterDetail" :dialogOptions="dialogOptions" :entityKey="entityKey"
    entityName="report_template" entitySpec="row" :requiredFields="{
      report_template_code: true,
      report_template_name: true,
      report_template_sysname: false,
      report_state_id: true,
      company_ids: true,
    }" :dictionary="TEMPLATE_DICTIONARY">
    <template #header="{ rowData }">
      <label data-testid="header_report_template">{{
        rowId === -1
          ? 'Новый шаблона'
          : `Редактирование шаблона № ${rowId} ${rowData ? rowData.report_template_name : ''
          }`
      }}</label>
    </template>
    <template #body="{ rowData, reference, submitted }">
      <div class="formgrid grid align-items-center vertical-container mt-3">
        <div class="col-1">
          <label for="report_name" class="mb-1">Отчет:</label>
        </div>
        <div class="col-5">
          <InputText id="report_name" autofocus :value="dialogOptions.reportName" disabled />
        </div>
        <div class="col-1">
          <label for="date_transfer">ID отчёта:</label>
        </div>
        <div class="col-2">
          <InputText autofocus :value="masterDetail.report_id" disabled />
        </div>
        <div class="col-1">
          <label for="report_template_code">Код:</label>
        </div>
        <div class="col-2">
          <Dropdown id="report_template_code" v-model="rowData.report_template_code"
            :options="reference['code'] ? reference['code'] : []" optionLabel="code" optionValue="code"
            placeholder="Код" appendTo="body" :class="{
              'p-invalid':
                submitted ? (rowData.report_template_code || '') == '' : false,
            }" />
        </div>
      </div>
      <div class="formgrid grid align-items-center vertical-container mt-3">
        <div class="col-2">
          <label for="report_state_id" class="mb-1">Состояние:</label>
        </div>
        <div class="col-2">
          <Dropdown id="report_state_id" v-model="rowData.report_state_id" :options="reference.reportStates"
            optionLabel="report_state_sname" optionValue="report_state_id" placeholder="Состояние" appendTo="body"
            :class="{
              'p-invalid':
                submitted ? (rowData.report_state_id || '') == '' : false,
            }" />
        </div>

        <div class="col-2">
          <label for="date_transfer">Компании:</label>
        </div>
        <div class="col-6">
          <MultiSelect v-model="rowData.company_ids" :options="reference.companies" optionLabel="company_mark"
            optionValue="company_id" placeholder="Компании" appendTo="body" :class="{
              'p-invalid': submitted ? (rowData.company_ids || '') == '' : false,
            }">
            <template #option="slotProps">
              <div>{{ slotProps.option.company_name }}</div>
            </template>
          </MultiSelect>
        </div>
      </div>
      <div class="formgrid grid align-items-center vertical-container mt-3">
        <div class="col-2">
          <label for="report_template_name" class="mb-1">Имя шаблона:</label>
        </div>
        <div class="col-3">
          <InputText id="report_template_name" v-model="rowData.report_template_name" :class="{
            'p-invalid':
              submitted ? (rowData.report_template_name || '') == '' : false,
          }" />
        </div>
        <div class="col-2">
          <label for="report_template_sysname">Сист. имя шаблона:</label>
        </div>
        <div class="col-3">
          <InputText autofocus v-model="rowData.report_template_sysname" :class="{
            'p-invalid':
              submitted ? (rowData.report_template_sysname || '') == '' : false,
          }" />
        </div>
        <div class="col-1">
          <label for="row_is_ready">Готовность:</label>
        </div>
        <div class="col-1 text-center">
          <Checkbox id="row_is_ready" v-model="rowData.row_is_ready" binary />
        </div>
      </div>
      <div class="formgrid grid align-items-center vertical-container mt-3">
        <div class="col-2">
          <label for="state_name" class="mb-1">Примечание:</label>
        </div>
        <div class="col-10">
          <Textarea id="description" v-model="rowData.report_template_desc" rows="2" cols="20" />
        </div>
      </div>
    </template>
  </ViewCustomRow>
</template>

<script>
import { ViewCustomRow } from 'cdisoft-library';
import { TEMPLATE_DICTIONARY } from './reportConstants';

export default {
  name: 'TemplateDialog',
  mixins: [ViewCustomRow],
  setup() {
    const prepareUpdate = (rowData, masterDetail) => {
      const data = {
        report_id: masterDetail.report_id,
        report_template_code: rowData.report_template_code,
        report_template_name: rowData.report_template_name,
        report_template_sysname: rowData.report_template_sysname,
        report_state_id: rowData.report_state_id,
        company_ids: rowData.company_ids.join(','),
        report_template_desc: rowData.report_template_desc,
        row_is_ready: rowData.row_is_ready,
      };
      return data;
    };

    const prepareInsert = (rowData, masterDetail) => {
      return prepareUpdate(rowData, masterDetail);
    };

    const prepareData = (rowData) => {
      return Object.assign(rowData, {
        company_ids: rowData.company_ids.split(',').map(Number),
      });
    };

    const beforeOpenNewRow = (rowData, dialogOptions) => {
      rowData.report_template_code = dialogOptions ? dialogOptions.numberTemplates + 1 : 1;
      rowData.report_state_id = 1;
      rowData.company_ids = [200000];
      rowData.report_template_desc = null;
      rowData.row_is_ready = false;
    };

    return {
      TEMPLATE_DICTIONARY,

      prepareInsert,
      prepareUpdate,
      prepareData,
      beforeOpenNewRow,
    };
  },
};
</script>